module.exports = __webpack_public_path__ + "static/demo-screen-4-7eec9fd5faacdf4264e3893129349de2.jpg";